import { useEffect } from "react";
import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { initAnalytics, initMarketing } from "@/lib/trackers";

/**
 * Bootstraps analytics/marketing only when consent is given.
 * Analytics/marketing NEVER load before user has made a choice (consent === null) or has rejected.
 * Use in PublicLayout and AppLayout so trackers init only after accept.
 */
export function useTrackersBootstrap(): void {
  const { canUseAnalytics, canUseMarketing, consent } = useCookieConsent();

  useEffect(() => {
    if (!consent) return; // no choice yet → do not load any tracker
    if (canUseAnalytics()) initAnalytics();
    if (canUseMarketing()) initMarketing();
  }, [consent, canUseAnalytics, canUseMarketing]);
}
